export module SearchEvents {
	export function KeywordChanged() {

	}
}